export const SITE = {
  url: process.env.REACT_APP_SITE_URL,
  name: '樹記海鮮',
  englishName: 'Shukee Seafood Company Limited',
  logo: 'https://customer-assets.emergentagent.com/job_freshcatch-5/artifacts/b5in0ucy_logo.jpg',
  defaultImage: 'https://images.unsplash.com/photo-1615141982883-c7ad0e69fd62?w=1200',
  telephone: '+85225439248',
  email: 'info@shukee.com.hk',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Stall A41, Western Wholesale Food Market, Sai Ying Pun',
    addressLocality: 'Hong Kong',
    addressCountry: 'HK',
  },
};

export const languageTags = { tc: 'zh-Hant-HK', cn: 'zh-Hans-CN', en: 'en-HK' };

const metadata = {
  home: {
    tc: ['香港海鮮批發及環球食材供應｜樹記海鮮', '樹記海鮮為香港餐飲業提供新鮮活海鮮、急凍海產及環球食材，配合專業冷鏈物流、品質追溯和 ESG 可持續發展策略。'],
    cn: ['香港海鲜批发及环球食材供应｜树记海鲜', '树记海鲜为香港餐饮业提供新鲜活海鲜、冷冻海产及环球食材，配合专业冷链物流、品质追溯和 ESG 可持续发展策略。'],
    en: ['Hong Kong Seafood Wholesale & Global Ingredients | Shukee Seafood', 'Shukee Seafood supplies fresh, live and frozen seafood to Hong Kong’s foodservice industry with traceable sourcing, professional cold-chain logistics and ESG-led practices.'],
  },
  about: {
    tc: ['樹記海鮮的故事｜香港海鮮批發商', '了解樹記海鮮自 1958 年起服務香港餐飲業的故事，以及我們對新鮮、品質、客戶服務與可持續發展的堅持。'],
    cn: ['树记海鲜的故事｜香港海鲜批发商', '了解树记海鲜自 1958 年起服务香港餐饮业的故事，以及我们对新鲜、品质、客户服务与可持续发展的坚持。'],
    en: ['Our Story | Shukee Seafood Hong Kong', 'Discover how Shukee Seafood has served Hong Kong’s foodservice industry since 1958, guided by freshness, quality, service and sustainability.'],
  },
  products: {
    tc: ['海鮮及食材產品｜龍蝦、蟹、鮮魚、急凍海產｜樹記海鮮', '瀏覽樹記海鮮的環球食材系列，包括新鮮活魚、急凍魚、龍蝦、蟹、蝦、貝類、肉類及加工食物，服務香港餐飲業。'],
    cn: ['海鲜及食材产品｜龙虾、蟹、鲜鱼、冷冻海产｜树记海鲜', '浏览树记海鲜的环球食材系列，包括新鲜活鱼、冷冻鱼、龙虾、蟹、虾、贝类、肉类及加工食物，服务香港餐饮业。'],
    en: ['Seafood & Food Ingredients | Lobster, Crab, Fish | Shukee Seafood', 'Explore Shukee Seafood’s wholesale range of live fish, frozen fish, lobster, crab, prawns, shellfish, meat and prepared foods for Hong Kong foodservice.'],
  },
  awards: {
    tc: ['冷鏈物流及品質優勢｜樹記海鮮', '認識樹記海鮮的專業冷藏運輸、冷凍設備、養殖設施及加工物流服務，為香港餐飲業提供可靠的新鮮食材供應。'],
    cn: ['冷链物流及品质优势｜树记海鲜', '认识树记海鲜的专业冷藏运输、冷冻设备、养殖设施及加工物流服务，为香港餐饮业提供可靠的新鲜食材供应。'],
    en: ['Cold Chain, Quality & Service Advantages | Shukee Seafood', 'Learn about Shukee Seafood’s refrigerated fleet, cold-chain facilities, aquaculture systems and processing support for reliable foodservice supply.'],
  },
  blog: {
    tc: ['海鮮資訊、ESG 與食材故事｜樹記海鮮', '閱讀樹記海鮮最新資訊，了解優質海產、食材溯源、環保創新及香港餐飲業的可持續發展故事。'],
    cn: ['海鲜资讯、ESG 与食材故事｜树记海鲜', '阅读树记海鲜最新资讯，了解优质海产、食材溯源、环保创新及香港餐饮业的可持续发展故事。'],
    en: ['Seafood News, ESG & Ingredient Stories | Shukee Seafood', 'Read Shukee Seafood news on premium ingredients, traceability, environmental innovation and sustainable foodservice in Hong Kong.'],
  },
  contact: {
    tc: ['聯絡樹記海鮮｜香港海鮮批發查詢', '聯絡樹記海鮮查詢新鮮海產、環球食材及餐飲業供應服務。我們位於西營盤西區副食品批發市場。'],
    cn: ['联系树记海鲜｜香港海鲜批发查询', '联系树记海鲜查询新鲜海产、环球食材及餐饮业供应服务。我们位于西营盘西区副食品批发市场。'],
    en: ['Contact Shukee Seafood | Hong Kong Seafood Wholesale', 'Contact Shukee Seafood for fresh seafood, global ingredients and foodservice supply enquiries. Find us at Western Wholesale Food Market, Sai Ying Pun.'],
  },
};

export const getPageMetadata = (page, language) => {
  const [title, description] = metadata[page][language] || metadata[page].tc;
  return { title, description };
};

export const companySchema = () => ({
  '@type': 'Organization',
  '@id': `${SITE.url}/#organization`,
  name: SITE.englishName,
  alternateName: SITE.name,
  url: SITE.url,
  logo: SITE.logo,
  email: SITE.email,
  telephone: SITE.telephone,
  address: SITE.address,
  areaServed: { '@type': 'AdministrativeArea', name: 'Hong Kong' },
  contactPoint: [{ '@type': 'ContactPoint', telephone: SITE.telephone, contactType: 'sales', areaServed: 'HK', availableLanguage: ['Chinese', 'English'] }],
});

export const productCollectionSchema = (language) => ({
  '@type': 'CollectionPage',
  name: getPageMetadata('products', language).title,
  url: `${SITE.url}/products`,
  about: ['Live Fish', 'Frozen Fish', 'Lobster', 'Crab', 'Shrimp', 'Shellfish'].map((name) => ({ '@type': 'Thing', name })),
  provider: { '@id': `${SITE.url}/#organization` },
});

export const blogCollectionSchema = (posts, language) => ({
  '@type': 'Blog',
  name: getPageMetadata('blog', language).title,
  url: `${SITE.url}/blog`,
  publisher: { '@id': `${SITE.url}/#organization` },
  blogPost: posts.map((post) => ({
    '@type': 'BlogPosting',
    headline: post[`title_${language}`] || post.title_tc,
    url: `${SITE.url}/blog/${post.post_id}`,
  })),
});

export const blogPostSchema = (post, language) => ({
  '@type': 'BlogPosting',
  headline: post[`title_${language}`] || post.title_tc,
  image: post.image_url ? [post.image_url] : [SITE.defaultImage],
  datePublished: post.created_at,
  dateModified: post.updated_at || post.created_at,
  mainEntityOfPage: `${SITE.url}/blog/${post.post_id}`,
  author: { '@type': 'Organization', name: SITE.englishName, url: SITE.url },
  publisher: { '@id': `${SITE.url}/#organization` },
});